module.exports = __webpack_public_path__ + "img/dario-dominguez-byn.8a1d7004.png";